


import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Modal, Badge } from "react-bootstrap";
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';
import DefaultData from '../../Common/CompanyData/DefaultData';

const Home = () => {
    // Data States (Your Original States)
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);

    // Modal States (Your Original States)
    const [showProductModal, setShowProductModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedImagePreview, setSelectedImagePreview] = useState('');

    // Service Search State (Your Original State)
    const [serviceSearch, setServiceSearch] = useState('');

    const navigate = useNavigate();
    const THEME_COLOR = '#065f46';
    
    // Get currency from DefaultData
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';

    useEffect(() => {
        loadAllData();
    }, []);

    const loadAllData = async () => {
        try {
            const [catRes, prodRes, imgRes, brandRes] = await Promise.all([
                axios.get(config.APIACTIVEURL + config.GETALLCATEGORIES),
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTS),
                axios.get(config.APIACTIVEURL + config.GETALLPRODUCTIMAGES),
                axios.get(config.APIACTIVEURL + config.GETALLBRANDS)
            ]);

            setCategories(catRes.data || []);
            setProducts(prodRes.data || []);
            setAllImages(imgRes.data || []);
            setBrands(brandRes.data || []);
        } catch (error) {
            console.error("Error fetching home data", error);
        } finally {
            setLoading(false);
        }
    };

    const handleServiceSearchSubmit = (e) => {
        e.preventDefault();
        if (serviceSearch.trim()) {
            navigate(`/services/search?q=${encodeURIComponent(serviceSearch.trim())}`);
        } else {
            alert("Please enter a service to search");
        }
    };

    // --- Your Original Helpers ---
    const getFullImageUrl = (path) => {
        if (!path) return 'https://placehold.co/300x300?text=No+Image';
        if (path.startsWith('http')) return path;
        const baseUrl = config.APIACTIVEURL.replace('/api/', '');
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${cleanPath}`;
    };

    const getMainImage = (prodId) => {
        const img = allImages.find(x => x.productId === prodId);
        return img ? getFullImageUrl(img.imageSrc) : 'https://placehold.co/300x300?text=No+Image';
    };

    const getCategoryName = (catId) => {
        const cat = categories.find(c => c.categoryId === catId);
        return cat ? cat.name : 'Uncategorized';
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        const defaultImg = getMainImage(product.productId);
        setSelectedImagePreview(defaultImg);
        setShowProductModal(true);
    };

    return (
        <div style={{ backgroundColor: '#fafaf9', minHeight: '100vh', paddingTop: '100px' }} className="mt-lg-4">

            {/* ================= HERO SECTION ================= */}
            <div className="container py-lg-5 py-3">
                <div className="row align-items-center g-4 g-lg-5">
                    {/* Centered text on mobile, left-aligned on web */}
                    <div className="col-lg-7 text-center text-lg-start">
                        <div className="badge rounded-pill mb-3 px-3 py-2" style={{ backgroundColor: '#d1fae5', color: '#065f46', fontSize: '0.75rem', fontWeight: '800', letterSpacing: '0.05rem' }}>
                            ✨ Premium Products & Service discovery
                        </div>
                        <h1 className="display-2 fw-bold mb-4" style={{ color: '#064e3b', lineHeight: '1.1', fontSize: 'calc(1.8rem + 3vw)' }}>
                            Define Your <br />
                            <span className="fst-italic" style={{ color: '#065f46' }}>Unique</span> Look
                        </h1>
                        <p className="fs-5 text-muted mb-5 px-2 px-lg-0">
                            Discover and book the finest beauty professionals in your area.
                        </p>
                        <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-3">
                            <div className="d-flex ms-2">
                                {[11, 12, 13, 14].map(i => (
                                    <img key={`avatar-${i}`} src={`https://i.pravatar.cc/100?img=${i}`} className="rounded-circle border border-4 border-white shadow-sm" style={{ width: '50px', height: '50px', marginLeft: '-15px' }} alt="user" />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <div className="card border-0 shadow-lg p-4 p-lg-5" style={{ borderRadius: '2rem' }}>
                            <h3 className="fw-bold mb-4" style={{ color: '#064e3b' }}>Find a Service</h3>
                            <form onSubmit={handleServiceSearchSubmit}>
                                <div className="d-grid gap-4">
                                    <input
                                        type="text"
                                        className="form-control bg-light border-0 py-3 rounded-4 px-3"
                                        placeholder="Search services..."
                                        value={serviceSearch}
                                        onChange={(e) => setServiceSearch(e.target.value)}
                                        required
                                    />
                                    <button type="submit" className="btn btn-lg py-3 rounded-4 fw-bold text-white shadow-lg border-0 mt-2" style={{ backgroundColor: '#065f46' }}>
                                        Search
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= POPULAR CATEGORIES ================= */}
            <div className="bg-white py-5 mt-lg-5 mt-4">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="h4 h-lg-3 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>Popular Categories</h2>
                        <Link to="/all-categories" className="text-decoration-none fw-bold small" style={{ color: '#065f46' }}>View All</Link>
                    </div>

                    {loading ? <p>Loading...</p> : (
                        <div className="row g-3 g-lg-4">
                            {categories.slice(0, 8).map(cat => (
                                /* col-6 for mobile (2 items), col-lg-3 for web (4 items) */
                                <div className="col-6 col-md-4 col-lg-3" key={cat.categoryId}>
                                    <div 
                                        className="card border-0 shadow-sm h-100 text-center p-3 p-lg-4" 
                                        style={{ borderRadius: '1.5rem', cursor: 'pointer' }}
                                        onClick={() => navigate(`/salons-by-category/${cat.categoryId}/${encodeURIComponent(cat.name)}`)}
                                    >
                                        <img src={getFullImageUrl(cat.imageSrc)} alt={cat.name} className="rounded-circle mx-auto mb-3" style={{ width: '70px', height: '70px', objectFit: 'cover' }} />
                                        <h6 className="fw-bold mb-0 small">{cat.name}</h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* ================= TRENDING PRODUCTS ================= */}
            <div className="py-5" style={{ backgroundColor: '#f3f4f6' }}>
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="h4 h-lg-3 fw-bold mb-0 border-bottom border-4 pb-2" style={{ borderColor: '#d1fae5' }}>Trending Products</h2>
                        <Link to="/products/search" className="text-decoration-none fw-bold small" style={{ color: '#065f46' }}>
                            View All
                        </Link>
                    </div>

                    {loading ? <p>Loading...</p> : (
                        <div className="row g-3 g-lg-4">
                            {products.slice(0, 8).map(prod => {
                                const imgSrc = getMainImage(prod.productId);

                                return (
                                    /* col-6 for mobile, col-lg-3 for web */
                                    <div className="col-6 col-md-6 col-lg-3" key={prod.productId}>
                                        <div 
                                            className="card border-0 shadow-sm h-100 overflow-hidden" 
                                            style={{ borderRadius: '1.5rem', cursor: 'pointer' }}
                                            onClick={() => handleProductClick(prod)}
                                        >
                                            {/* Logic to prevent image cutting: contain + white background */}
                                            <div style={{ backgroundColor: '#fff', textAlign: 'center' }}>
                                                <img src={imgSrc} alt={prod.productName} style={{ width: '100%', height: '200px', objectFit: 'contain', padding: '10px' }} />
                                            </div>
                                            <div className="card-body p-3 p-lg-4 bg-white">
                                                <h6 className="fw-bold mb-1 text-dark text-truncate small">{prod.productName}</h6>
                                                <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mt-3 gap-2">
                                                    <span className="fw-bold fs-6" style={{ color: THEME_COLOR }}>{currency} {prod.sellingPrice}</span>
                                                    <Badge bg={prod.quantityAvailable > 0 ? "success" : "danger"} style={{ fontSize: '0.6rem' }}>
                                                        {prod.quantityAvailable > 0 ? "In Stock" : "Out of Stock"}
                                                    </Badge>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>

            {/* ================= MODAL (Original Logic) ================= */}
            <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="lg" centered>
                <Modal.Body className="p-4">
                    {selectedProduct && (
                        <div className="row g-4 text-start">
                            <div className="col-md-6">
                                <div style={{ backgroundColor: '#f9f9f9', borderRadius: '15px' }}>
                                    <img src={selectedImagePreview} className="w-100 rounded-4" style={{ height: '350px', objectFit: 'contain', padding: '10px' }} alt="Preview" />
                                </div>
                                <div className="row g-2 mt-2">
                                    {allImages.filter(img => img.productId === selectedProduct.productId).map((img, idx) => (
                                        <div className="col-3" key={`thumb-${idx}`}>
                                            <img 
                                                src={getFullImageUrl(img.imageSrc)} 
                                                className="w-100 rounded border" 
                                                style={{ height: '60px', objectFit: 'cover', cursor: 'pointer' }} 
                                                onClick={() => setSelectedImagePreview(getFullImageUrl(img.imageSrc))}
                                                alt="thumb"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-md-6 d-flex flex-column">
                                <h3 className="fw-bold">{selectedProduct.productName}</h3>
                                <p className="text-muted">{getCategoryName(selectedProduct.categoryId)}</p>
                                <h2 className="fw-bold" style={{ color: THEME_COLOR }}>{currency} {selectedProduct.sellingPrice}</h2>
                                <p className="mt-4 small">{selectedProduct.description}</p>
                                <button 
                                    className="btn w-100 py-3 rounded-pill text-white fw-bold mt-auto"
                                    style={{ backgroundColor: THEME_COLOR }}
                                    onClick={() => navigate(`/product-details/${selectedProduct.productId}`)}
                                >
                                    View Full Details
                                </button>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* ================= FOOTER (All Original Links Intact) ================= */}
            <footer className="bg-white pt-5 pb-4 mt-5 border-top border-light position-relative">
                <div className="container">
                    <div className="row align-items-center mb-4">
                        {/* Payment methods center on mobile */}
                        <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
                            <span className="text-dark fs-5 fw-medium">Payment methods:</span>
                            <div className="d-flex gap-3 mt-3 align-items-center justify-content-center justify-content-md-start">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" style={{ height: '22px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="PayPal" style={{ height: '22px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" alt="MasterCard" style={{ height: '25px' }} />
                                <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg" alt="Amex" style={{ height: '22px' }} />
                            </div>
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <span className="text-dark fs-5 fw-medium">Keep in touch</span>
                            <div className="d-flex gap-3 justify-content-center justify-content-md-end mt-3 fs-3 text-secondary">
                                <i className="ri-facebook-box-fill"></i>
                                <i className="ri-twitter-x-line"></i>
                                <i className="ri-instagram-line"></i>
                                <i className="ri-threads-line"></i>
                            </div>
                        </div>
                    </div>

                    <hr className="my-5" style={{ borderTop: '1px dotted #dee2e6' }} />

                    <div className="text-center">
                        <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
                            <a href="/Frequently-Asked-Questions.pdf" target="_blank" className="text-decoration-none fw-medium text-dark small">FAQ</a>
                            <a href="/Partner-Terms.pdf" target="_blank" className="text-decoration-none fw-medium text-dark small">Partner Terms</a>
                            <a href="/Terms-and-Condition.pdf" target="_blank" className="text-decoration-none fw-medium text-dark small">Terms & Conditions</a>
                            <a href="/Privacy-Policy.pdf" target="_blank" className="text-decoration-none fw-medium text-dark small">Privacy Policy</a>
                        </div>
                        <p className="small text-muted mb-0">Copyright © 2026 <span className="fw-bold text-dark">Munny Finds</span>. All Rights Reserved</p>
                    </div>

                    {/* Scroll to Top - Your Original Button */}
                    <button 
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
                        className="btn position-absolute bottom-0 end-0 m-4 rounded-circle d-flex align-items-center justify-content-center shadow-sm" 
                        style={{ backgroundColor: '#86efac', width: '50px', height: '50px', border: 'none', color: 'white' }}
                    >
                        <i className="ri-arrow-up-line fs-4"></i>
                    </button>
                </div>
            </footer>
        </div>
    );
};

export default Home;